import { Flame } from 'lucide-react'

export function Logo({ className = '' }: { className?: string }) {
  return (
    <span className={`inline-flex items-center gap-2 font-semibold tracking-tight text-fg ${className}`}>
      <span className="inline-flex size-7 items-center justify-center rounded-lg bg-accent text-accent-fg">
        <Flame size={16} strokeWidth={2.25} />
      </span>
      Завод
    </span>
  )
}
